<div class="orders-page">

    <!-- HEADER -->
    <div class="page-head d-flex justify-content-between align-items-center flex-wrap gap-2">
        <div>
            <h4 class="text-teal fw-bold mb-1 d-flex align-items-center gap-2">
                <i class="bi bi-bag-check"></i>
                My Orders
            </h4>
            <small class="text-muted">
                <i class="bi bi-info-circle me-1"></i>
                Track and manage your orders
            </small>
        </div>

        <div class="header-actions">

            <!-- 🔍 SEARCH -->
            <div class="search-box input-group input-group-sm">
                <span class="input-group-text bg-white border-end-0">
                    <i class="bi bi-search"></i>
                </span>
                <input class="form-control border-start-0" placeholder="Search order no..."
                    (input)="onSearch($any($event.target).value)">
            </div>

            <!-- 🚚 TRACK -->
            <div class="tracking-box input-group input-group-sm">
                <span class="input-group-text bg-white">
                    <i class="bi bi-upc-scan"></i>
                </span>
                <input class="form-control" placeholder="Tracking No" [(ngModel)]="trackingNo">

                <button class="btn btn-teal" (click)="trackOrderNow()">
                    Track
                </button>
            </div>

            <!-- RESET -->
            <button class="btn btn-soft btn-sm reset-btn" (click)="resetFilters()">
                <i class="bi bi-arrow-counterclockwise"></i>
                Reset
            </button>

        </div>
    </div>

    <!-- ❌ ERROR -->
    <div class="text-danger mt-2" *ngIf="trackingError">
        {{ trackingError }}
    </div>

    <!-- FILTERS -->
    <div class="filters-card mt-3">
        <div class="row g-2">

            <div class="col-md-3">
                <label class="small text-muted">
                    <i class="bi bi-funnel"></i> Status
                </label>
                <select class="form-select form-select-sm" [(ngModel)]="query.status" (change)="applyFilters()">
                    <option *ngFor="let s of statusOptions" [value]="s.value">
                        {{ s.label }}
                    </option>
                </select>
            </div>

            <div class="col-md-3">
                <label class="small text-muted">
                    <i class="bi bi-truck"></i> Method
                </label>
                <input class="form-control form-control-sm" [(ngModel)]="query.method" (change)="applyFilters()">
            </div>

            <div class="col-md-2">
                <label class="small text-muted">
                    <i class="bi bi-cash"></i> Min Total
                </label>
                <input type="number" class="form-control form-control-sm" [(ngModel)]="query.minTotal"
                    (change)="applyFilters()">
            </div>

            <div class="col-md-2">
                <label class="small text-muted">
                    <i class="bi bi-cash-stack"></i> Max Total
                </label>
                <input type="number" class="form-control form-control-sm" [(ngModel)]="query.maxTotal"
                    (change)="applyFilters()">
            </div>

            <div class="col-md-2">
                <label class="small text-muted">
                    <i class="bi bi-sort-down"></i> Sort
                </label>
                <select class="form-select form-select-sm" (change)="setSort($any($event.target).value)">
                    <option *ngFor="let s of sortOptions" [value]="s.value">
                        {{ s.label }}
                    </option>
                </select>
            </div>

        </div>
    </div>

    <!-- TABLE -->
    <div class="card-soft mt-3">

        <div class="card-soft-head d-flex justify-content-between">
            <div>
                <i class="bi bi-list-ul me-1"></i>
                Showing <b>{{ orders.length }}</b> of <b>{{ total }}</b>
            </div>

            <div *ngIf="loading">
                <i class="bi bi-arrow-repeat spin"></i> Loading...
            </div>
        </div>

        <div class="table-responsive">
            <table class="table orders-table">
                <thead>
                    <tr>
                        <th><i class="bi bi-hash"></i> Track No</th>
                        <th><i class="bi bi-hash"></i> Order</th>
                        <th><i class="bi bi-cash-coin"></i> Total</th>
                        <th><i class="bi bi-truck"></i> Method</th>
                        <th><i class="bi bi-flag"></i> Status</th>
                        <th><i class="bi bi-calendar"></i> Date</th>
                        <th class="text-end"><i class="bi bi-gear"></i> Action</th>
                    </tr>
                </thead>

                <tbody>

                    <tr *ngIf="loading">
                        <td colspan="6" class="text-center">
                            <i class="bi bi-arrow-repeat spin"></i> Loading...
                        </td>
                    </tr>

                    <tr *ngIf="!loading && orders.length === 0">
                        <td colspan="6">
                            <div class="empty-state">
                                <div class="empty-icon">
                                    <i class="bi bi-bag-x"></i>
                                </div>
                                <div class="fw-bold text-teal">No orders found</div>
                                <div class="text-muted small">
                                    Try changing filters
                                </div>
                            </div>
                        </td>
                    </tr>

                    <tr *ngFor="let o of orders">

                        <td>
                            <span class="chip-mono copyable" (click)="copyTracking(o.shipping?.trackingNo)">

                                <i class="bi" [ngClass]="copiedTracking === o.shipping?.trackingNo 
     ? 'bi-check-circle text-success' 
     : 'bi-upc-scan'">
                                </i>

                                {{ o.shipping?.trackingNo || '—' }}

                                <!-- 🔥 COPIED TEXT -->
                                <span class="copied-text" *ngIf="copiedTracking === o.shipping?.trackingNo">
                                    Copied!
                                </span>

                            </span>
                        </td>

                        <td>
                            <span class="chip-mono">
                                #{{ o.orderNo }}
                            </span>
                        </td>

                        <td>
                            <span class="price-pill">
                                <i class="bi bi-currency-dollar"></i>
                                {{ o.currency }} {{ o.grandTotal }}
                            </span>
                        </td>

                        <td>
                            <span class="chip-soft">
                                <i class="bi bi-truck"></i>
                                {{ o.fulfillmentMethod }}
                            </span>
                        </td>

                        <td>
                            <span class="status-pill" [ngClass]="o.status.toLowerCase()">
                                <i class="bi" [ngClass]="{
                                     'bi-hourglass-split': o.status==='processing',
                                     'bi-truck': o.status==='dispatched',
                                     'bi-check-circle': o.status==='delivered',
                                     'bi-x-circle': o.status==='cancelled'
                                   }">
                                </i>
                                {{ o.status }}
                            </span>
                        </td>

                        <td>
                            <i class="bi bi-clock me-1"></i>
                            {{ o.createdAt | date:'short' }}
                        </td>

                        <td class="text-end">
                            <button class="btn btn-soft btn-sm d-flex align-items-center gap-1"
                                (click)="openOrder(o._id)">
                                <i class="bi bi-eye"></i>
                                View
                            </button>
                        </td>

                    </tr>

                </tbody>
            </table>
        </div>

        <!-- PAGINATION -->
        <div class="pagi d-flex justify-content-between align-items-center">
            <div>
                <i class="bi bi-layers"></i>
                Page <b>{{ query.page }}</b> of <b>{{ totalPages }}</b>
            </div>

            <div class="d-flex gap-2">
                <button class="btn btn-soft btn-sm" (click)="goToPage(query.page-1)">
                    <i class="bi bi-chevron-left"></i>
                </button>

                <button class="btn btn-soft btn-sm" (click)="goToPage(query.page+1)">
                    <i class="bi bi-chevron-right"></i>
                </button>
            </div>
        </div>

    </div>

</div>



<!-- Tracking -->
<!-- 🔥 TRACKING MODAL -->
<div class="modal-backdrop-soft" *ngIf="trackingModalOpen" (click)="closeTrackingModal()"></div>

<div class="modal-soft tracking-modal" *ngIf="trackingModalOpen">

    <div class="modal-soft-card" (click)="$event.stopPropagation()">

        <!-- HEADER -->
        <div class="modal-soft-head d-flex justify-content-between">
            <div class="fw-bold text-teal">
                🚚 Track Order
            </div>

            <button class="btn btn-soft btn-sm" (click)="closeTrackingModal()">
                <i class="bi bi-x-lg"></i>
            </button>
        </div>

        <!-- LOADING -->
        <div *ngIf="trackingLoading" class="text-center p-4">
            <i class="bi bi-arrow-repeat spin"></i>
            Loading...
        </div>

        <!-- CONTENT -->
        <div *ngIf="trackingResult" class="tracking-body">

            <!-- 🔥 LOTTIE (CDN BASED) -->
            <div class="lottie-box">
                <div id="lottieContainer"></div>
            </div>

            <!-- ORDER INFO -->
            <div class="text-center">
                <h5 class="fw-bold">
                    {{ trackingResult.orderNo }}
                </h5>

                <div class="text-muted">
                    {{ trackingResult.trackingNo }}
                </div>

                <span class="status-pill big mt-2" [ngClass]="trackingResult.status.toLowerCase()">
                    {{ formatStatus(trackingResult.status) }}
                </span>
            </div>

            <!-- TIMELINE -->
            <div class="timeline-pro mt-4">

                <div class="step" *ngFor="let s of ['Processing','Dispatched','Delivered']; let i = index" [ngClass]="{
            'done': getStepIndex(trackingResult.status) > i,
            'active': getStepIndex(trackingResult.status) === i
          }">

                    <div class="circle"></div>
                    <div class="label">{{ s }}</div>

                </div>

            </div>

            <!-- EVENTS -->
            <div class="tracking-list mt-4">

                <div class="tracking-item" *ngFor="let e of trackingResult.events">

                    <div class="dot"></div>

                    <div>
                        <div class="fw-semibold">
                            {{ formatStatus(e.status) }}
                        </div>

                        <div class="small text-muted">
                            {{ e.note }}
                        </div>

                        <div class="small text-muted">
                            {{ e.at | date:'short' }}
                        </div>
                    </div>

                </div>

            </div>

        </div>

    </div>
</div>

<!-- BACKDROP -->
<div class="modal-backdrop-soft" *ngIf="modalOpen" (click)="closeModal()"></div>

<!-- MODAL -->
<div class="modal-soft" *ngIf="modalOpen">
    <div class="modal-soft-card" (click)="$event.stopPropagation()">

        <!-- HEADER -->
        <div class="modal-soft-head d-flex justify-content-between">
            <div class="fw-bold text-teal d-flex align-items-center gap-2">
                <i class="bi bi-receipt"></i> Order Details
            </div>

            <button class="btn btn-soft btn-sm" (click)="closeModal()">
                <i class="bi bi-x-lg"></i>
            </button>
        </div>

        <!-- LOADING -->
        <div *ngIf="modalLoading" class="p-4 text-center">
            <i class="bi bi-arrow-repeat spin"></i> Loading...
        </div>

        <!-- CONTENT -->
        <div *ngIf="!modalLoading && selectedOrder" class="modal-soft-body">

            <!-- 🔥 HEADER CARD -->
            <div class="order-header-card">
                <div>
                    <div class="order-id">#{{ selectedOrder.orderNo }}</div>
                    <div class="date">
                        <i class="bi bi-clock"></i>
                        {{ selectedOrder.createdAt | date:'medium' }}
                    </div>
                </div>

                <div class="text-end">
                    <div class="amount">
                        {{ selectedOrder.currency }} {{ selectedOrder.grandTotal }}
                    </div>

                    <span class="status-pill big" [ngClass]="selectedOrder.status.toLowerCase()">
                        {{ formatStatus(selectedOrder.status) }}
                    </span>
                </div>
            </div>

            <!-- 🔥 TIMELINE -->
            <div class="timeline-pro mt-4">
                <div class="step" *ngFor="let s of ['Processing','Dispatched','Delivered']; let i = index" [ngClass]="{
            'done': getStepIndex(selectedOrder.status) > i,
            'active': getStepIndex(selectedOrder.status) === i
          }">

                    <div class="circle">
                        <i class="bi" [ngClass]="{
                'bi-check': getStepIndex(selectedOrder.status) > i,
                'bi-hourglass-split': i === 0,
                'bi-truck': i === 1,
                'bi-check-circle': i === 2
              }">
                        </i>
                    </div>

                    <div class="label">{{ s }}</div>
                </div>
            </div>

            <!-- 📦 ITEMS -->
            <div class="mt-4" *ngIf="selectedOrder?.items?.length">
                <div class="fw-bold text-teal mb-2">
                    <i class="bi bi-box-seam"></i> Items
                </div>

                <table class="table">
                    <tr *ngFor="let i of selectedOrder.items">
                        <td>
                            <div class="fw-semibold">
                                {{ i.productSnapshot?.name }}
                            </div>
                            <div class="small text-muted">
                                {{ i.productSnapshot?.sizeLabel }}
                            </div>
                        </td>
                        <td>x{{ i.quantity }}</td>
                        <td>{{ selectedOrder.currency }} {{ i.lineTotal }}</td>
                    </tr>
                </table>
            </div>

            <!-- 📘 PROTOCOL -->
            <div class="mt-4" *ngIf="selectedOrder.protocolId">
                <div class="fw-bold text-teal mb-2">
                    <i class="bi bi-diagram-3"></i> Protocol
                </div>

                <div class="details-grid">
                    <div>
                        <div class="mini-label">Name</div>
                        <div class="mini-value">
                            {{ selectedOrder.protocolId.templateSnapshot?.name }}
                        </div>
                    </div>

                    <div>
                        <div class="mini-label">Start</div>
                        <div class="mini-value">
                            {{ selectedOrder.protocolId.startDate | date }}
                        </div>
                    </div>

                    <div>
                        <div class="mini-label">Next Due</div>
                        <div class="mini-value">
                            {{ selectedOrder.protocolId.nextDueDate | date }}
                        </div>
                    </div>

                    <div>
                        <div class="mini-label">Status</div>
                        <div class="mini-value">
                            {{ selectedOrder.protocolId.status }}
                        </div>
                    </div>
                </div>
            </div>

            <!-- 🚚 SHIPPING -->
            <div class="mt-4" *ngIf="selectedOrder.shipping">
                <div class="fw-bold text-teal mb-2">
                    <i class="bi bi-truck"></i> Shipping
                </div>

                <div class="details-grid">
                    <div>
                        <div class="mini-label">Tracking</div>
                        <div class="mini-value">
                            {{ selectedOrder.shipping.trackingNo }}
                        </div>
                    </div>

                    <div>
                        <div class="mini-label">Courier</div>
                        <div class="mini-value">
                            {{ selectedOrder.shipping.courier || '—' }}
                        </div>
                    </div>
                </div>
            </div>

            <!-- 📍 TRACKING EVENTS -->
            <div class="mt-4" *ngIf="selectedOrder.shipping?.trackingEvents?.length">
                <div class="fw-bold text-teal mb-2">
                    <i class="bi bi-geo"></i> Tracking History
                </div>

                <div class="tracking-list">
                    <div class="tracking-item" *ngFor="let t of selectedOrder.shipping.trackingEvents">

                        <div class="dot"></div>

                        <div>
                            <div class="fw-semibold">
                                {{ formatStatus(t.status) }}
                            </div>
                            <div class="small text-muted">{{ t.note }}</div>
                            <div class="small text-muted">{{ t.at | date:'short' }}</div>
                        </div>

                    </div>
                </div>
            </div>

            <!-- 💳 BILLING -->
            <div class="mt-4">
                <div class="fw-bold text-teal mb-2">
                    <i class="bi bi-receipt-cutoff"></i> Billing
                </div>

                <div class="details-grid">
                    <div>
                        <div class="mini-label">Subtotal</div>
                        <div class="mini-value">
                            {{ selectedOrder.currency }} {{ selectedOrder.subTotal }}
                        </div>
                    </div>

                    <div>
                        <div class="mini-label">Discount</div>
                        <div class="mini-value">
                            {{ selectedOrder.currency }} {{ selectedOrder.discountAmount }}
                        </div>
                    </div>

                    <div>
                        <div class="mini-label">Total</div>
                        <div class="mini-value fw-bold text-teal">
                            {{ selectedOrder.currency }} {{ selectedOrder.grandTotal }}
                        </div>
                    </div>

                    <div>
                        <div class="mini-label">Invoice</div>
                        <div class="mini-value">

                            <span class="status-chip" [ngClass]="getInvoiceClass(selectedOrder.invoiceStatus)">

                                <i class="bi" [ngClass]="getInvoiceIcon(selectedOrder.invoiceStatus)">
                                </i>

                                {{ formatStatus(selectedOrder.invoiceStatus) }}

                            </span>

                        </div>
                    </div>
                </div>
            </div>

        </div>

    </div>
</div>